/** Audit F-038: flag buildings already in the register while a new one is being named. */
const normalise=(value:string)=>value.toLocaleLowerCase('en-GB').replace(/[^a-z0-9]+/g,' ').trim();

export function similarBuildings<T extends {name:string}>(draftName:string,buildings:readonly T[]|undefined,limit=5):T[]{
 const draft=normalise(draftName);
 if(draft.length<4)return [];
 return (buildings??[]).filter(building=>{const name=normalise(building.name);const words=(value:string)=>` ${value} `;return name.length>=4&&(name===draft||words(name).includes(words(draft))||words(draft).includes(words(name)));}).slice(0,limit);
}
